module.exports = __webpack_public_path__ + "img/transnistria.18b1cc27.svg";